// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image--exk19{width:24px;height:24px;-o-object-fit:contain;object-fit:contain;margin-right:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": "image--exk19"
};
export default ___CSS_LOADER_EXPORT___;
